export default __webpack_public_path__ + "static/Home-banner-2x-2be10a517206c0dc9370492135e75901.png";